import React, {Component} from 'react';
import styles from './styles.css';
import {observable, action} from 'mobx';
import {observer} from 'mobx-react';
import {ListItem} from 'react-toolbox/lib/list';

@observer
export default class ExpandableListItem extends Component {
  @observable isOpen = false;

  @action toggleOpen = () => {
    this.isOpen = !this.isOpen;
  };

  render() {
    const {title, children, faulty} = this.props;
    return (
      <div>
        <ListItem
          theme={styles}
          className={faulty ? styles.faulty : null}
          selectable
          caption={title}
          onClick={this.toggleOpen}
        />
        {this.isOpen
          ? children
          : null }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ExpandableListItem/ExpandableListItem.js